import { render, staticRenderFns } from "./home-projects.vue?vue&type=template&id=0b014b05&scoped=true&"
import script from "./home-projects.vue?vue&type=script&lang=js&"
export * from "./home-projects.vue?vue&type=script&lang=js&"
import style0 from "./home-projects.vue?vue&type=style&index=0&id=0b014b05&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b014b05",
  null
  
)

export default component.exports